module.exports = __webpack_public_path__ + "static/media/kmusic.8ecf7828.svg";